// Components
import { PerformanceAreaScreen } from "./performance-area.component";

export default PerformanceAreaScreen;
